import React, { useEffect } from "react";

import "./portal.scss"

// Declaración global para PureCounter en window
declare global {
  interface Window {
    PureCounter?: any;
  }
}

export const PortalHome2: React.FC = () => {

  const [tabIndex, setTabIndex] = React.useState<string>('home');

  // Datos de ejemplo de profesionales
  const profesionalesData = [
    {
      nombre: 'Walter White',
      consultorio: 'Av. Spinetto 670, Santa Rosa',
      localidad: 'Santa Rosa',
      telefono: '2954-123456',
      matricula: '1234',
      cuit: '20-12345678-9',
      especialidades: ['Fonoaudiología', 'Audiología'],
      atiendeObraSocial: true,
      redes: {
        twitter: 'https://twitter.com',
        facebook: 'https://facebook.com',
        instagram: 'https://instagram.com',
        linkedin: 'https://linkedin.com',
      },
    },
    {
      nombre: 'Sarah Jhonson',
      consultorio: 'Belgrano 123, General Pico',
      localidad: 'General Pico',
      telefono: '2954-654321',
      matricula: '5678',
      cuit: '27-87654321-0',
      especialidades: ['Voz', 'Lenguaje'],
      atiendeObraSocial: false,
      redes: {
        // twitter: 'https://twitter.com',
        facebook: 'https://facebook.com',
        instagram: 'https://instagram.com',
        // linkedin: 'https://linkedin.com',
      },
    },
    {
      nombre: 'William Anderson',
      consultorio: 'Rivadavia 456, Santa Rosa',
      localidad: 'Santa Rosa',
      telefono: '2954-789012',
      matricula: '9101',
      cuit: '23-11223344-5',
      especialidades: ['Odontoesmatología', 'Deglución'],
      atiendeObraSocial: true,
      redes: {
        twitter: 'https://twitter.com',
        facebook: 'https://facebook.com',
        instagram: 'https://instagram.com',
        linkedin: 'https://linkedin.com',
      },
    },
    {
      nombre: 'Amanda Jepson',
      consultorio: 'San Martín 789, Toay',
      localidad: 'Toay',
      telefono: '2954-345678',
      matricula: '1121',
      cuit: '27-55667788-1',
      especialidades: ['Rehabilitación', 'Audiología'],
      atiendeObraSocial: true,
      redes: {
        twitter: 'https://twitter.com',
        facebook: 'https://facebook.com',
        instagram: 'https://instagram.com',
        linkedin: 'https://linkedin.com',
      },
    },
    // Nuevos profesionales de ejemplo
    {
      nombre: 'Lucía Fernández',
      consultorio: 'Av. Luro 1500, Santa Rosa',
      localidad: 'Santa Rosa',
      telefono: '2954-111222',
      matricula: '2233',
      cuit: '27-33445566-2',
      especialidades: ['Lenguaje', 'Fonoaudiología'],
      atiendeObraSocial: true,
      redes: {
        twitter: '',
        facebook: 'https://facebook.com/luciaf',
        instagram: 'https://instagram.com/luciaf',
        linkedin: '',
      },
    },
    {
      nombre: 'Martín Gómez',
      consultorio: 'Calle 9 N° 456, General Pico',
      localidad: 'General Pico',
      telefono: '2954-333444',
      matricula: '3344',
      cuit: '20-99887766-3',
      especialidades: ['Audiología'],
      atiendeObraSocial: false,
      redes: {
        twitter: 'https://twitter.com/mgomez',
        facebook: '',
        instagram: '',
        linkedin: 'https://linkedin.com/in/mgomez',
      },
    },
    {
      nombre: 'Paula Sosa',
      consultorio: 'Av. Perón 234, Toay',
      localidad: 'Toay',
      telefono: '2954-555666',
      matricula: '4455',
      cuit: '23-44556677-8',
      especialidades: ['Voz', 'Rehabilitación'],
      atiendeObraSocial: true,
      redes: {
        twitter: '',
        facebook: '',
        instagram: 'https://instagram.com/paulasosa',
        linkedin: '',
      },
    },
    {
      nombre: 'Federico Ruiz',
      consultorio: 'Mitre 800, Santa Rosa',
      localidad: 'Santa Rosa',
      telefono: '2954-777888',
      matricula: '5566',
      cuit: '20-22334455-6',
      especialidades: ['Odontoesmatología', 'Lenguaje', 'Deglución'],
      atiendeObraSocial: false,
      redes: {
        twitter: 'https://twitter.com/federicoruiz',
        facebook: '',
        instagram: '',
        linkedin: '',
      },
    },
    {
      nombre: 'María López',
      consultorio: 'Calle 25 N° 100, General Pico',
      localidad: 'General Pico',
      telefono: '2954-999000',
      matricula: '6677',
      cuit: '27-77889900-1',
      especialidades: ['Fonoaudiología'],
      atiendeObraSocial: true,
      redes: {
        twitter: '',
        facebook: 'https://facebook.com/marialopez',
        instagram: '',
        linkedin: '',
      },
    },
  ];

  // Estado de filtros
  const [filtroNombre, setFiltroNombre] = React.useState('');
  const [filtroLocalidad, setFiltroLocalidad] = React.useState('');
  const [filtroObraSocial, setFiltroObraSocial] = React.useState('');
  const [filtroEspecialidad, setFiltroEspecialidad] = React.useState('');

  // Obtener opciones únicas de localidad y especialidad
  const localidades = Array.from(new Set(profesionalesData.map(p => p.localidad)));
  const especialidades = Array.from(new Set(profesionalesData.flatMap(p => p.especialidades)));

  // Filtrado de profesionales
  const profesionalesFiltrados = profesionalesData.filter(p => {
    const matchNombre = p.nombre.toLowerCase().includes(filtroNombre.toLowerCase()) || 
                       p.matricula.toLowerCase().includes(filtroNombre.toLowerCase());
    const matchLocalidad = !filtroLocalidad || p.localidad === filtroLocalidad;
    const matchObraSocial =
      !filtroObraSocial ||
      (filtroObraSocial === 'si' && p.atiendeObraSocial) ||
      (filtroObraSocial === 'no' && !p.atiendeObraSocial);
    const matchEspecialidad =
      !filtroEspecialidad || p.especialidades.includes(filtroEspecialidad);
    return matchNombre && matchLocalidad && matchObraSocial && matchEspecialidad;
  });

  useEffect(() => {
  if (tabIndex === 'institucional' && window.PureCounter) {
    new window.PureCounter();
  }
}, [tabIndex]);

  useEffect(() => {
    // Cargar scripts JS solo cuando el portal está montado
    const scripts = [
      './assets/portal/vendor/bootstrap/js/bootstrap.bundle.min.js',
      './assets/portal/vendor/php-email-form/validate.js',
      './assets/portal/vendor/aos/aos.js',
      './assets/portal/vendor/glightbox/js/glightbox.min.js',
      './assets/portal/vendor/purecounter/purecounter_vanilla.js',
      './assets/portal/js/main.js',
    ];
    const scriptElements = scripts.map(src => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
      return script;
    });
    // Cargar fuentes solo para el portal
    const fontLinks = [
      { href: 'https://fonts.googleapis.com', rel: 'preconnect' },
      { href: 'https://fonts.gstatic.com', rel: 'preconnect', crossorigin: 'anonymous' },
      { href: 'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap', rel: 'stylesheet' },
    ];
    const linkElements = fontLinks.map(props => {
      const link = document.createElement('link');
      Object.entries(props).forEach(([key, value]) => link.setAttribute(key, value));
      document.head.appendChild(link);
      return link;
    });
    // Cargar estilos CSS solo para el portal
    const cssLinks = [
      '/assets/portal/vendor/bootstrap/css/bootstrap.min.css',
      '/assets/portal/vendor/bootstrap-icons/bootstrap-icons.css',
      '/assets/portal/vendor/aos/aos.css',
      '/assets/portal/vendor/fontawesome-free/css/all.min.css',
      '/assets/portal/vendor/glightbox/css/glightbox.min.css',
      '/assets/portal/vendor/swiper/swiper-bundle.min.css',
      '/assets/portal/css/main.css',
    ];
    const cssElements = cssLinks.map(href => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
      return link;
    });
    return () => {
      scriptElements.forEach(script => {
        if (document.body.contains(script)) document.body.removeChild(script);
      });
      linkElements.forEach(link => {
        if (document.head.contains(link)) document.head.removeChild(link);
      });
      cssElements.forEach(link => {
        if (document.head.contains(link)) document.head.removeChild(link);
      });
    };
  }, []);

  return (
    <>
      {/* HEADER - ESTILO TENUE */}
      <header id="header" className="header sticky-top">
        <div className="topbar d-flex align-items-center" style={{
          background: 'linear-gradient(135deg, rgba(156, 163, 175, 0.85) 0%, rgba(209, 213, 219, 0.85) 50%, rgba(229, 231, 235, 0.85) 100%)',
          backdropFilter: 'blur(15px)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
          boxShadow: '0 2px 15px rgba(0, 0, 0, 0.05)',
          padding: '12px 0',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Elemento decorativo de fondo suave */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: `
              radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.15) 0%, transparent 50%),
              radial-gradient(circle at 80% 50%, rgba(156, 163, 175, 0.1) 0%, transparent 50%)
            `,
            zIndex: 1
          }} />
          
          <div className="container d-flex justify-content-center justify-content-md-between" style={{
            position: 'relative',
            zIndex: 2
          }}>
            <div className="d-none d-md-flex align-items-center" style={{
              color: '#4b5563',
              fontSize: '0.9rem',
              fontWeight: '500',
              fontFamily: "'Inter', sans-serif",
              textShadow: '0 1px 2px rgba(255, 255, 255, 0.8)',
              letterSpacing: '0.2px'
            }}>
              <i className="bi bi-building me-2" style={{
                fontSize: '1rem',
                color: '#d4a574'
              }}></i> 
              Colegio Profesional de Fonoaudiólogos de La Pampa
            </div>
            <a 
              href="https://wa.me/5429542954702284?text=Hola,%20necesito%20información%20sobre%20los%20servicios%20del%20Colegio%20de%20Fonoaudiólogos" 
              target="_blank" 
              rel="noopener noreferrer"
              className="d-flex align-items-center"
              style={{
                color: '#374151',
                fontSize: '0.9rem',
                fontWeight: '500',
                fontFamily: "'Inter', sans-serif",
                textShadow: '0 1px 2px rgba(255, 255, 255, 0.5)',
                letterSpacing: '0.2px',
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                padding: '8px 15px',
                borderRadius: '20px',
                backgroundColor: 'rgba(255, 255, 255, 0.6)',
                backdropFilter: 'blur(8px)',
                border: '1px solid rgba(156, 163, 175, 0.3)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(34, 197, 94, 0.1)';
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(34, 197, 94, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.6)';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <i className="bi bi-whatsapp me-2" style={{
                fontSize: '1rem',
                color: '#22c55e',
                animation: 'softPulse 3s infinite'
              }}></i> 
              Contáctanos por WhatsApp
            </a>
          </div>
        </div>
        <div className="branding d-flex align-items-center">
          <div className="container position-relative d-flex align-items-center justify-content-end">
            <a href="index.html" className="logo d-flex align-items-center me-auto">
              <img src="assets/img/logo-cofolp.png" alt="" />
            </a>
            <nav id="navmenu" className="navmenu">
              <ul>
                <li><a href="#" className="active" onClick={() => setTabIndex('home')}>Inicio</a></li>
                <li className="dropdown"><a href='#' onClick={() => setTabIndex('institucional')}><span>Institucional</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href='#' onClick={() => setTabIndex('institucional')}>Quiénes somos?</a></li>
                    <li><a href='#' onClick={() => setTabIndex('institucional')}>Comisión Directiva</a></li>
                    <li><a href='#' onClick={() => setTabIndex('institucional')}>Tribunal de Etica y Disciplina</a></li>
                    <li><a href='#' onClick={() => setTabIndex('institucional')}>Comisión Revisora de Cuentas</a></li>
                  </ul>
                </li>
                <li className="dropdown"><a href="#" onClick={() => setTabIndex('tramites')}><span>Trámites</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href="#" onClick={() => setTabIndex('matriculacion')}>Matriculación</a></li>
                    <li><a href="#" onClick={() => setTabIndex('consultorio')}>Consultorio</a></li>
                    <li><a href="#" onClick={() => setTabIndex('tramites')}>Título</a></li>
                    <li><a href="#" onClick={() => setTabIndex('tramites')}>Baja de Matrícula</a></li>
                    <li><a href='#' onClick={() => setTabIndex('ejercicio-profesional')}>Habilitación de Consultorio</a></li>
                  </ul>
                </li>
                <li className="dropdown"><a href='#' onClick={() => setTabIndex('ejercicio-profesional')}><span>Ejercicio Profesional</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href='#' onClick={() => setTabIndex('ejercicio-profesional')}>Honorarios Mínimos</a></li>
                    <li><a href='#' onClick={() => setTabIndex('ejercicio-profesional')}>Código de ética</a></li>
                    <li><a href="#" onClick={() => setTabIndex('certificado-etica')}>Certificado de ética</a></li>
                    <li><a href='#' onClick={() => setTabIndex('ejercicio-profesional')}>Consentimiento informado</a></li>
                    <li><a href='#' onClick={() => setTabIndex('ejercicio-profesional')}>Habilitación de Consultorio</a></li>
                  </ul>
                </li>
                <li><a href="#" onClick={() => setTabIndex('profesionales')}>Profesionales</a></li>
                <li><a href="#">Obras Sociales</a></li>
                <li><a href="#" onClick={() => setTabIndex('contacto')}>Contacto</a></li>
              </ul>
              <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
            </nav>
            <a className="cta-btn" href="http://145.223.94.120/" target="_blank" rel="noopener noreferrer">AUTOGESTION</a>
          </div>
        </div>
      </header>
      
      
      {/* MAIN CONTENT */}
      <main className="main">
        {tabIndex === 'home' && (
          <>
            <section id="hero" className="hero section" style={{
              position: 'relative',
              height: '400px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 25%, #e5e7eb 50%, #d1d5db 75%, #f9fafb 100%)',
              backgroundSize: '400% 400%',
              animation: 'softGradientShift 20s ease infinite',
              overflow: 'hidden',
            }}>
              
              {/* Elementos de fondo suaves */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: `
                  radial-gradient(circle at 25% 25%, rgba(229, 231, 235, 0.4) 0%, transparent 60%),
                  radial-gradient(circle at 75% 75%, rgba(209, 213, 219, 0.3) 0%, transparent 60%),
                  radial-gradient(circle at 50% 50%, rgba(243, 244, 246, 0.2) 0%, transparent 60%)
                `,
                zIndex: 1
              }} />
              
              {/* Patrón geométrico sutil */}
              <div style={{
                position: 'absolute',
                top: '-50%',
                left: '-50%',
                width: '200%',
                height: '200%',
                backgroundImage: `
                  linear-gradient(45deg, rgba(156, 163, 175, 0.05) 25%, transparent 25%),
                  linear-gradient(-45deg, rgba(156, 163, 175, 0.05) 25%, transparent 25%),
                  linear-gradient(45deg, transparent 75%, rgba(156, 163, 175, 0.05) 75%),
                  linear-gradient(-45deg, transparent 75%, rgba(156, 163, 175, 0.05) 75%)
                `,
                backgroundSize: '80px 80px',
                backgroundPosition: '0 0, 0 40px, 40px -40px, -40px 0px',
                animation: 'softPatternFloat 30s linear infinite',
                zIndex: 2
              }} />
              
              {/* Círculos flotantes suaves */}
              <div style={{
                position: 'absolute',
                top: '15%',
                right: '10%',
                width: '250px',
                height: '250px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, rgba(249, 250, 251, 0.6), rgba(229, 231, 235, 0.3))',
                backdropFilter: 'blur(15px)',
                animation: 'gentleFloat 8s ease-in-out infinite',
                zIndex: 2
              }} />
              
              <div style={{
                position: 'absolute',
                bottom: '15%',
                left: '8%',
                width: '180px',
                height: '180px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, rgba(243, 244, 246, 0.5), rgba(209, 213, 219, 0.3))',
                backdropFilter: 'blur(12px)',
                animation: 'gentleFloat 10s ease-in-out infinite reverse',
                zIndex: 2
              }} />
              
              {/* Overlay principal suave */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: `
                  linear-gradient(135deg, 
                    rgba(249, 250, 251, 0.7) 0%, 
                    rgba(243, 244, 246, 0.6) 25%,
                    rgba(229, 231, 235, 0.5) 50%,
                    rgba(243, 244, 246, 0.6) 75%,
                    rgba(249, 250, 251, 0.7) 100%
                  )
                `,
                backdropFilter: 'blur(2px)',
                zIndex: 3
              }} />
              
              {/* Contenido principal */}
              <div style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                position: 'relative',
                zIndex: 4,
                padding: '60px 0'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '55%',
                  height: '100%',
                  position: 'relative'
                }}>
                  
                  <video
                    src="/assets/portal/img/Logo_CFLP_2.mp4"
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="logo-animation animated-logo"
                    style={{
                      maxHeight: '100%',
                      maxWidth: '100%',
                      width: 'auto',
                      height: 'auto',
                      objectFit: 'contain',
                      filter: 'drop-shadow(0 4px 12px rgba(107, 114, 128, 0.2))',
                      display: 'block',
                      opacity: 0,
                      transform: 'translateY(20px)',
                      animation: 'softFadeIn 1.8s ease-out 0.4s forwards',
                      borderRadius: '12px'
                    }}
                  />
                </div>
                <div
                  className="banner-text"
                  style={{
                    width: '45%',
                    height: 'auto',
                    maxWidth: '600px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '40px 30px',
                    margin: '20px',
                    textAlign: 'center',
                    background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(249, 250, 251, 0.8) 100%)',
                    backdropFilter: 'blur(20px)',
                    borderRadius: '25px',
                    border: '2px solid rgba(229, 231, 235, 0.5)',
                    boxShadow: '0 20px 40px rgba(107, 114, 128, 0.1), 0 8px 25px rgba(156, 163, 175, 0.1)',
                    position: 'relative',
                    overflow: 'hidden',
                    opacity: 0,
                    transform: 'translateY(30px)',
                    animation: 'softSlideUp 1.8s ease-out 0.9s forwards'
                  }}
                >
                  {/* Elemento decorativo suave */}
                  <div style={{
                    position: 'absolute',
                    top: '-40%',
                    right: '-25%',
                    width: '150px',
                    height: '150px',
                    background: 'linear-gradient(45deg, rgba(229, 231, 235, 0.3), transparent)',
                    borderRadius: '50%',
                    zIndex: 1
                  }} />
                  
                  {/* Contenido del texto */}
                  <div style={{ position: 'relative', zIndex: 2 }}>
                    <h2 style={{
                      color: '#374151',
                      fontSize: '2.2rem',
                      fontWeight: '600',
                      lineHeight: '1.3',
                      textShadow: '0 2px 4px rgba(107, 114, 128, 0.1)',
                      margin: 0,
                      fontFamily: "'Inter', sans-serif",
                      letterSpacing: '-0.3px',
                      marginBottom: '15px'
                    }}>
                      Cuidando la<br />
                      <span style={{
                        background: 'linear-gradient(135deg, #d4a574 0%, #e2c89c 50%, #f0dbb8 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        fontWeight: '700',
                        fontSize: '2.4rem'
                      }}>
                        Fonoaudiología
                      </span>
                      <br />en nuestra región
                    </h2>
                    
                    <div style={{
                      width: '50px',
                      height: '2px',
                      background: 'linear-gradient(90deg, #d4a574, #e2c89c)',
                      margin: '20px auto',
                      borderRadius: '1px'
                    }} />
                    
                    <p style={{
                      fontSize: '1.2rem',
                      fontWeight: '400',
                      color: '#6b7280',
                      margin: 0,
                      fontFamily: "'Inter', sans-serif",
                      letterSpacing: '0.1px',
                      textShadow: '0 1px 2px rgba(255, 255, 255, 0.8)'
                    }}>
                      Profesionalismo • Compromiso • Bienestar
                    </p>
                  </div>
                </div>
              </div>
              
              <style>{`
                /* Animaciones suaves para PortalHome2 */
                @keyframes softFadeIn {
                  0% {
                    opacity: 0;
                    transform: translateY(15px) scale(0.98);
                  }
                  100% {
                    opacity: 1;
                    transform: translateY(0) scale(1);
                  }
                }
                
                @keyframes softSlideUp {
                  0% {
                    opacity: 0;
                    transform: translateY(25px) scale(0.97);
                  }
                  100% {
                    opacity: 1;
                    transform: translateY(0) scale(1);
                  }
                }
                
                @keyframes softGradientShift {
                  0% {
                    background-position: 0% 50%;
                  }
                  50% {
                    background-position: 100% 50%;
                  }
                  100% {
                    background-position: 0% 50%;
                  }
                }
                
                @keyframes softPulse {
                  0%, 100% {
                    opacity: 0.8;
                    transform: scale(1);
                  }
                  50% {
                    opacity: 1;
                    transform: scale(1.02);
                  }
                }
                
                @keyframes softPatternFloat {
                  0% {
                    transform: translateX(0) translateY(0);
                  }
                  50% {
                    transform: translateX(-5px) translateY(-10px);
                  }
                  100% {
                    transform: translateX(0) translateY(0);
                  }
                }
                
                @keyframes gentleFloat {
                  0%, 100% {
                    transform: translateY(0px) scale(1);
                  }
                  50% {
                    transform: translateY(-10px) scale(1.01);
                  }
                }
                
                /* Responsive para PortalHome2 */
                @media (max-width: 768px) {
                  .topbar {
                    padding: 10px 0 !important;
                  }
                  
                  #hero {
                    min-height: 380px !important;
                  }
                  
                  .banner-text {
                    display: none !important;
                  }
                  
                  #hero > div:last-child {
                    justify-content: center !important;
                  }
                  
                  #hero > div:last-child > div:first-child {
                    width: 100% !important;
                    flex-direction: column !important;
                  }
                  
                  .animated-logo {
                    height: 160px !important;
                    width: auto !important;
                  }
                }
                
                @media (max-width: 480px) {
                  .animated-logo {
                    height: 130px !important;
                    width: auto !important;
                  }
                }
              `}</style>
            </section>

            {/* Featured Services Section - ESTILO TENUE */}
            <section id="featured-services" className="featured-services section" style={{
              background: 'linear-gradient(135deg, #fefefe 0%, #f9fafb 100%)',
              padding: '50px 0',
              position: 'relative',
              overflow: 'hidden'
            }}>
              {/* Elementos decorativos suaves */}
              <div style={{
                position: 'absolute',
                top: '-80px',
                right: '-80px',
                width: '300px',
                height: '300px',
                background: 'linear-gradient(135deg, rgba(243, 244, 246, 0.6), rgba(229, 231, 235, 0.4))',
                borderRadius: '50%',
                zIndex: 1
              }} />

              <div className="container" style={{ position: 'relative', zIndex: 2 }}>
                <div className="row gy-4 justify-content-center">
                  {/* Servicio 1: Acceso a AUTOGESTION - Tonos suaves */}
                  <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                    <div className="soft-service-card" style={{
                      background: 'linear-gradient(135deg, rgba(243, 244, 246, 0.8) 0%, rgba(249, 250, 251, 0.9) 100%)',
                      backdropFilter: 'blur(15px)',
                      borderRadius: '20px',
                      padding: '35px 25px',
                      textAlign: 'center',
                      border: '2px solid rgba(229, 231, 235, 0.6)',
                      boxShadow: '0 15px 35px rgba(107, 114, 128, 0.08)',
                      transition: 'all 0.4s ease',
                      cursor: 'pointer',
                      position: 'relative',
                      overflow: 'hidden',
                      height: '100%',
                      minHeight: '300px'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-5px) scale(1.01)';
                      e.currentTarget.style.boxShadow = '0 25px 50px rgba(107, 114, 128, 0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0) scale(1)';
                      e.currentTarget.style.boxShadow = '0 15px 35px rgba(107, 114, 128, 0.08)';
                    }}
                    onClick={() => window.open('http://145.223.94.120/', '_blank')}>
                      
                      <div style={{ position: 'relative', zIndex: 2 }}>
                        <div className="soft-service-icon" style={{
                          width: '70px',
                          height: '70px',
                          background: 'linear-gradient(135deg, #9ca3af, #6b7280)',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto 20px',
                          boxShadow: '0 8px 25px rgba(107, 114, 128, 0.2)'
                        }}>
                          <i className="fas fa-laptop-code" style={{
                            fontSize: '1.8rem',
                            color: 'white'
                          }}></i>
                        </div>
                        
                        <h4 style={{
                          fontSize: '1.3rem',
                          fontWeight: '500',
                          color: '#374151',
                          marginBottom: '15px',
                          fontFamily: "'Inter', sans-serif"
                        }}>
                          Acceso a AUTOGESTION
                        </h4>
                        
                        <p style={{
                          color: '#6b7280',
                          fontSize: '0.95rem',
                          lineHeight: '1.5',
                          margin: 0,
                          fontFamily: "'Inter', sans-serif"
                        }}>
                          Gestione sus trámites, consulte su estado de cuenta y acceda a servicios digitales.
                        </p>
                        
                        <div style={{
                          marginTop: '18px',
                          padding: '8px 18px',
                          background: 'linear-gradient(90deg, #9ca3af, #6b7280)',
                          color: 'white',
                          borderRadius: '20px',
                          fontSize: '0.85rem',
                          fontWeight: '400',
                          display: 'inline-block'
                        }}>
                          Ingresar →
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Servicio 2: Buscar Fonoaudiólogo - Tonos suaves */}
                  <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
                    <div className="soft-service-card" style={{
                      background: 'linear-gradient(135deg, rgba(239, 246, 255, 0.8) 0%, rgba(243, 244, 246, 0.9) 100%)',
                      backdropFilter: 'blur(15px)',
                      borderRadius: '20px',
                      padding: '35px 25px',
                      textAlign: 'center',
                      border: '2px solid rgba(196, 181, 253, 0.3)',
                      boxShadow: '0 15px 35px rgba(107, 114, 128, 0.08)',
                      transition: 'all 0.4s ease',
                      cursor: 'pointer',
                      position: 'relative',
                      overflow: 'hidden',
                      height: '100%',
                      minHeight: '300px'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-5px) scale(1.01)';
                      e.currentTarget.style.boxShadow = '0 25px 50px rgba(139, 92, 246, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0) scale(1)';
                      e.currentTarget.style.boxShadow = '0 15px 35px rgba(107, 114, 128, 0.08)';
                    }}
                    onClick={() => setTabIndex('profesionales')}>
                      
                      <div style={{ position: 'relative', zIndex: 2 }}>
                        <div className="soft-service-icon" style={{
                          width: '70px',
                          height: '70px',
                          background: 'linear-gradient(135deg, #a5b4fc, #8b5cf6)',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto 20px',
                          boxShadow: '0 8px 25px rgba(139, 92, 246, 0.2)'
                        }}>
                          <i className="fas fa-user-md" style={{
                            fontSize: '1.8rem',
                            color: 'white'
                          }}></i>
                        </div>
                        
                        <h4 style={{
                          fontSize: '1.3rem',
                          fontWeight: '500',
                          color: '#374151',
                          marginBottom: '15px',
                          fontFamily: "'Inter', sans-serif"
                        }}>
                          Buscar Fonoaudiólogo
                        </h4>
                        
                        <p style={{
                          color: '#6b7280',
                          fontSize: '0.95rem',
                          lineHeight: '1.5',
                          margin: 0,
                          fontFamily: "'Inter', sans-serif"
                        }}>
                          Encuentre profesionales por especialidad, localidad y cobertura.
                        </p>
                        
                        <div style={{
                          marginTop: '18px',
                          padding: '8px 18px',
                          background: 'linear-gradient(90deg, #a5b4fc, #8b5cf6)',
                          color: 'white',
                          borderRadius: '20px',
                          fontSize: '0.85rem',
                          fontWeight: '400',
                          display: 'inline-block'
                        }}>
                          Buscar →
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Servicio 3: Próximos Cursos y Eventos - Tonos suaves */}
                  <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
                    <div className="soft-service-card" style={{
                      background: 'linear-gradient(135deg, rgba(254, 252, 232, 0.8) 0%, rgba(249, 250, 251, 0.9) 100%)',
                      backdropFilter: 'blur(15px)',
                      borderRadius: '20px',
                      padding: '35px 25px',
                      textAlign: 'center',
                      border: '2px solid rgba(251, 191, 36, 0.3)',
                      boxShadow: '0 15px 35px rgba(107, 114, 128, 0.08)',
                      transition: 'all 0.4s ease',
                      cursor: 'pointer',
                      position: 'relative',
                      overflow: 'hidden',
                      height: '100%',
                      minHeight: '300px'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-5px) scale(1.01)';
                      e.currentTarget.style.boxShadow = '0 25px 50px rgba(251, 191, 36, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0) scale(1)';
                      e.currentTarget.style.boxShadow = '0 15px 35px rgba(107, 114, 128, 0.08)';
                    }}
                    onClick={() => {
                      alert('Sección de Cursos y Eventos próximamente disponible');
                    }}>
                      
                      <div style={{ position: 'relative', zIndex: 2 }}>
                        <div className="soft-service-icon" style={{
                          width: '70px',
                          height: '70px',
                          background: 'linear-gradient(135deg, #fde68a, #f59e0b)',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto 20px',
                          boxShadow: '0 8px 25px rgba(245, 158, 11, 0.2)'
                        }}>
                          <i className="fas fa-calendar-alt" style={{
                            fontSize: '1.8rem',
                            color: 'white'
                          }}></i>
                        </div>
                        
                        <h4 style={{
                          fontSize: '1.3rem',
                          fontWeight: '500',
                          color: '#374151',
                          marginBottom: '15px',
                          fontFamily: "'Inter', sans-serif"
                        }}>
                          Próximos Cursos y Eventos
                        </h4>
                        
                        <p style={{
                          color: '#6b7280',
                          fontSize: '0.95rem',
                          lineHeight: '1.5',
                          margin: 0,
                          fontFamily: "'Inter', sans-serif"
                        }}>
                          Capacitación continua y eventos de actualización profesional.
                        </p>
                        
                        <div style={{
                          marginTop: '18px',
                          padding: '8px 18px',
                          background: 'linear-gradient(90deg, #fde68a, #f59e0b)',
                          color: 'white',
                          borderRadius: '20px',
                          fontSize: '0.85rem',
                          fontWeight: '400',
                          display: 'inline-block'
                        }}>
                          Ver Eventos →
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}

        {/* Resto de secciones iguales al PortalHome original... */}
        {tabIndex === 'institucional' && (
          <>
           {/* Stats Section */}
            <section id="stats" className="stats section">
              <div className="container" data-aos="fade-up" data-aos-delay="100">
                <div className="row gy-4">
                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}

        {tabIndex === 'profesionales' && (
          <div className="profesionales">
            <section id="profesionales" className="professionals section" style={{
              background: 'linear-gradient(135deg, #fefefe 0%, #f9fafb 100%)',
              padding: '80px 0',
              position: 'relative',
              overflow: 'hidden'
            }}>
              {/* Elementos decorativos suaves */}
              <div style={{
                position: 'absolute',
                top: '-50px',
                right: '-50px',
                width: '300px',
                height: '300px',
                background: 'linear-gradient(135deg, rgba(243, 244, 246, 0.4), rgba(229, 231, 235, 0.3))',
                borderRadius: '50%',
                zIndex: 1
              }} />
              
              {/* Aquí iría el contenido de la sección de profesionales */}
            </section>
          </div>
        )}
      </main>
      
      {/* FOOTER - igual que el original */}
      <footer id="footer" className="footer">
        <div className="container">
          <div className="copyright text-center">
            <p>© <span>Copyright</span> <strong className="px-1 sitename">COFOLP</strong> <span>All Rights Reserved</span></p>
          </div>
          <div className="credits">
            Designed by <a href="#">COFOLP</a>
          </div>
        </div>
      </footer>
      
      <a href="#" id="scroll-top" className="scroll-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>
    </>
  );
};
